import React, { useState, useEffect } from 'react';
import { Button, Text, Icon } from './ui/index.jsx';

/**
 * Cookie Consent Banner Component
 * Required for EU GDPR compliance
 * Shows once on first visit, stores preference in localStorage
 * Note: Uses window.location instead of useNavigate because this component
 * is rendered outside the Router context in main.jsx
 */
export default function CookieConsent() {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        // Check if user has already given consent
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) {
            // Small delay to avoid flash on page load
            const timer = setTimeout(() => setShowBanner(true), 1000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAcknowledge = () => {
        localStorage.setItem('cookie_consent', JSON.stringify({
            acknowledged: true,
            timestamp: new Date().toISOString()
        }));
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up">
            <div className="max-w-4xl mx-auto">
                <div className="bg-[#1A1D26] border border-white/10 rounded-xl shadow-2xl backdrop-blur-xl p-6">
                    <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
                        {/* Icon */}
                        <div className="hidden md:flex items-center justify-center w-12 h-12 rounded-full bg-[#7B61FF]/20 flex-shrink-0">
                            <span className="text-2xl">🍪</span>
                        </div>

                        {/* Text Content */}
                        <div className="flex-1">
                            <Text variant="primary" weight="semibold" className="mb-1">
                                Essential Cookies
                            </Text>
                            <Text variant="secondary" size="sm">
                                We use strictly necessary cookies for authentication and security.
                                These cookies are required for the service to function and cannot be disabled.{' '}
                                <a
                                    href="/cookies"
                                    className="text-[#7B61FF] hover:text-[#8A6DFF] underline"
                                >
                                    Learn more
                                </a>
                            </Text>
                        </div>

                        {/* Button */}
                        <div className="flex w-full md:w-auto">
                            <Button
                                onClick={handleAcknowledge}
                                variant="primary"
                                size="sm"
                                className="whitespace-nowrap"
                            >
                                I Understand
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
                @keyframes slide-up {
                    from {
                        transform: translateY(100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }
                .animate-slide-up {
                    animation: slide-up 0.3s ease-out;
                }
            `}</style>
        </div>
    );
}
